var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInprocesssign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_371_1",
    "data-name": "Component 371 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0Z",
    fill: "#3CB23D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "time-forward-svgrepo-com",
    d: "M9.411,4.5A.409.409,0,0,0,9,4.907,4.1,4.1,0,1,1,7.816,2.036l-.041.009H6.549a.409.409,0,0,0,0,.818H7.775A1.227,1.227,0,0,0,9,1.636V.409a.409.409,0,0,0-.818,0v.844A4.9,4.9,0,1,0,9.82,4.907.409.409,0,0,0,9.411,4.5Zm-4.5-2.044a.409.409,0,0,0-.409.409V4.907a.409.409,0,0,0,.12.289L5.851,6.422a.409.409,0,1,0,.578-.578L5.322,4.737V2.862A.409.409,0,0,0,4.913,2.453Z",
    transform: "translate(2.989 3.238)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprocesssign);
export default __webpack_public_path__ + "static/media/inprocesssign.a4a59cedc0898bd817d6de6f5549e516.svg";
export { ForwardRef as ReactComponent };